"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapPopup = exports.MapPopupDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cross_icon_1 = require("../icons/cross.icon");
exports.MapPopupDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: #FFF;\n    z-index: 100;\n    position: relative;\n    border-radius: 10px;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);\n    margin-bottom: 10px;\n  "], ["\n    background: #FFF;\n    z-index: 100;\n    position: relative;\n    border-radius: 10px;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);\n    margin-bottom: 10px;\n  "])))
});
var CloseButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    cursor: pointer;\n    ", "\n\n    &:hover {\n      ", "\n    }\n  "], ["\n    ", ";\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    cursor: pointer;\n    ", "\n\n    &:hover {\n      ", "\n    }\n  "])), theme_1.theme.REMOVE_BUTTON_STYLE(), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.FILL('text'), theme_1.theme.FILL('link-hover'))
});
var CloseIconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 10px;\n    height: 10px;\n  "], ["\n    width: 10px;\n    height: 10px;\n  "])))
});
var TriangleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 0; \n    height: 0; \n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid #FFF;\n    position: absolute;\n    bottom: -9px;\n    left: 50%;\n    margin-left: -10px;\n  "], ["\n    width: 0; \n    height: 0; \n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid #FFF;\n    position: absolute;\n    bottom: -9px;\n    left: 50%;\n    margin-left: -10px;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  CloseButton: styled_components_1.default.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), CloseButtonStyles),
  CloseIcon: (0, styled_components_1.default)(cross_icon_1.Cross)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), CloseIconStyles),
  Triangle: styled_components_1.default.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), TriangleStyles)
};
var MapPopup = function (props) {
  var className = props.className,
    children = props.children,
    onClose = props.onClose;
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.CloseButton, {
    type: "button",
    onClick: onClose,
    title: "Close"
  }, react_1.default.createElement(My.CloseIcon, null)), children, react_1.default.createElement(My.Triangle, null));
};
exports.MapPopup = MapPopup;
exports.MapPopup.defaultProps = exports.MapPopupDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;